import { render, staticRenderFns } from "./CouponPreview.vue?vue&type=template&id=54abeace&scoped=true&"
import script from "./CouponPreview.vue?vue&type=script&lang=js&"
export * from "./CouponPreview.vue?vue&type=script&lang=js&"
import style0 from "./CouponPreview.vue?vue&type=style&index=0&id=54abeace&lang=scss&scoped=true&"
import style1 from "./CouponPreview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abeace",
  null
  
)

export default component.exports